// 模板 13：物联网设备与远程运维平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner1.png'),
        path: '',
        title: '海量设备统一接入管理',
        content:
          '帮助企业快速构建稳定可靠的物联网设备管理平台。'
      },
      {
        img: require('@/assets/img/banner_2.jpg'),
        path: '',
        title: '远程运维与故障预警',
        content:
          '实时监测设备状态，在问题扩大前及时处理。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '设备数据与运维中台',
      subtitle: '/ IoT Device Hub',
      paragraphs: [
        '集中管理各类终端设备数据，为运维人员提供统一工作入口。',
        '通过规则与模型监控关键指标，降低设备停机率。'
      ],
      buttonText: '预约演示'
    },
    contact: {
      title: '设备运维团队的左膀右臂',
      subTitle: '让设备运维从被动抢修走向主动预防',
      buttonText: '获取解决方案'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '云控物联科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__致力于为设备制造商与运维服务商提供统一的物联网平台与远程运维工具。',
      '平台已经在多类设备场景中得到验证，包括能源、环保与制造等行业。'
    ]
  },
  news: [
    {
      id: 'IOT01',
      title: '工业设备远程监控平台升级',
      introduce:
        '新版本支持更多类型协议与网关类型，接入灵活性进一步提升。',
      date: '01-08',
      year: '2025'
    },
    {
      id: 'IOT02',
      title: '发布运维工单移动端应用',
      introduce:
        '运维人员可以在手机端接收工单与查看设备状态，大幅提升响应效率。',
      date: '09-14',
      year: '2024'
    },
    {
      id: 'IOT03',
      title: '设备健康度评分模型上线',
      introduce:
        '结合运行趋势与故障记录，为关键设备生成健康度评分。',
      date: '05-30',
      year: '2024'
    },
    {
      id: 'IOT04',
      title: '与多家设备厂商达成合作',
      introduce:
        '共同为终端用户提供软硬一体的智能设备与运维解决方案。',
      date: '11-11',
      year: '2023'
    },
    {
      id: 'IOT05',
      title: '参与物联网安全标准研讨',
      introduce:
        '围绕设备接入安全与数据传输保护等议题分享实践经验。',
      date: '06-21',
      year: '2023'
    }
  ],
  software: {
    smartTown: {
      title: '设备接入与管理平台',
      sections: [
        {
          heading: '1. 多协议接入',
          content:
            '支持 MQTT、Modbus 等多种协议，便于快速接入存量设备。'
        },
        {
          heading: '2. 远程配置与升级',
          content:
            '支持批量下发配置与固件升级，降低现场维护成本。'
        },
        {
          heading: '3. 巡检与工单管理',
          content:
            '运维人员可配置巡检计划并记录处理过程，保障服务质量。'
        },
        {
          heading: '4. 告警管理',
          content:
            '告警集中管理，支持多种通知方式，避免遗漏。'
        }
      ]
    },
    bigData: {
      title: '设备运行数据分析平台',
      sections: [
        {
          heading: '1. 运行趋势分析',
          desc:
            '按时间维度分析运行参数趋势，识别异常波动。'
        },
        {
          heading: '2. 故障统计',
          desc:
            '按设备类型与区域统计故障发生情况，为改进提供依据。'
        },
        {
          heading: '3. 备件消耗分析',
          desc:
            '结合备件消耗与故障数据，优化备件库存策略。'
        },
        {
          heading: '4. 运维绩效评估',
          desc:
            '统计响应时长与工单完成情况，为运维团队绩效管理提供参考。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '物联网平台规划',
      engTitle: 'IoT Platform Design',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '设备接入改造',
      engTitle: 'Device Integration',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '运维体系搭建',
      engTitle: 'Ops System Build',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '长期托管运维',
      engTitle: 'Managed Ops',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '物联网解决方案架构师',
    responsibilities: [
      '负责物联网平台与运维方案架构设计；',
      '调研客户现场设备与网络环境，制定接入策略；',
      '协同项目团队保障方案顺利落地。'
    ],
    requirements: [
      '具备物联网或相关领域技术背景，了解常见协议与架构；',
      '具备良好的沟通能力与方案设计能力；',
      '对工业互联网与设备运维有兴趣。'
    ],
    buttonText: '投递简历'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-13.js